<div class="modal-dialog" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ (data.record ? 'profile.updateCvResume' : 'profile.addCvResume')
        | translate }}</h4>
      <button type="button" class="close" aria-label="Close" mat-dialog-close>
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group my-3">
        <app-file-manager class="one-col" [files]='files' [maxFileSize]='10' [maxFiles]="1" [isRequired]="true" [isSubmited]="isSubmited"
          [allowedExt]="['DOC', 'DOCX', 'PDF']" (selectedFiles)="files = $event"></app-file-manager>
      </div>
      <div class="modal-btns mt-4">
        <button type="button" class="close closebtn" mat-dialog-close>
          <span>{{ 'users.Cancel' | translate }}</span>
        </button>
        <button mat-raised-button class="btn customBtn" (click)="saveRecord()" [ngClass]="{ 'loading': loading}">
          <span>{{ (data.record ? 'profile.updateCvResume' : 'profile.addCvResume')
            | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
